import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../Components/SearchInput";
import SingleLineTitle from "../../Components/TitleElements/SingleLineTitle";
import AddButton from "../../Components/AddButton/AddButton";
import Button from "../../Components/Button/Button";
import { serviceConsumer } from "../../network/ServiceConsumer";
import Loader from "../../Components/Loader/Loader";
import CollaboratorTable from "./CollaboratorTable";
import AddCollabModal from "../../Components/Modals/OrganizerModel/ManageCollab/AddCollabModal";

// Big enough to pull the whole list in one request when "Show All" is used.
const LOAD_ALL = 100000;

const ManageCollaborators = () => {
    const [searchInput, setSearchInput] = useState("")
    const [openAddCollab, setOpenAddCollab] = useState(false)
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState("")
    const [hasFetched, setHasFetched] = useState(false)
    const [lastQuery, setLastQuery] = useState("")

    const levels = ["Adjudicator", "Musician", "Examiner", "Sponsor"]
    const navigate = useNavigate()

    // Nothing loads on arrival — the organizer searches, or asks for everyone.
    const getCollabs = async (searchVal = lastQuery) => {
        try {
            setLoading(true)
            const payload = { page: 1, type: filter, limit: LOAD_ALL, searchKey: searchVal }
            const collabUrl = `${process.env.REACT_APP_BASE_URL}/people/list`
            const res = await serviceConsumer("POST", collabUrl, payload)
            setList(res?.date?.list || [])
            setHasFetched(true)
            setLastQuery(searchVal)
            setLoading(false)
        } catch (err) {
            setLoading(false)
        }
    }

    // When the type filter changes, re-run the current view for the new type.
    useEffect(() => {
        if (hasFetched) getCollabs(lastQuery)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter])

    const submitSearch = (e) => {
        if (e) e.preventDefault();
        if (!searchInput.trim()) return;
        getCollabs(searchInput.trim());
    }

    const showAll = () => {
        setSearchInput("");
        getCollabs("");
    }

    const backToDashboardHandler = () => {
        localStorage.setItem("eventsTab", false)
        navigate("/")
    }

    const openAddCollabModal = () => setOpenAddCollab(true)
    const closeAddCollabModal = () => setOpenAddCollab(false)

    const hasData = list?.length > 0

    return (
        <>
            {loading && <Loader />}
            <SingleLineTitle titleName="Collaborators" onBackClick={backToDashboardHandler} />
            <div className="db-body">
                <form onSubmit={submitSearch} className="d-flex flex-column flex-md-row justify-content-between align-items-md-center pt-3" style={{ gap: "10px" }}>
                    <div className="col-sm-8 col-md-4 my-1 my-md-0">
                        <SearchInput searchInput={searchInput} setSearchInput={setSearchInput} />
                    </div>
                    <Button type="submit" className={searchInput.trim() ? "filled" : "disabled"}>Search</Button>
                    <Button type="button" className="outlined" onClick={showAll}>Show All</Button>
                    <div className="col-sm-8 col-md-2 my-2 my-md-0">
                        <select name="typeOfUser" className="dashboard-select" style={{ paddingLeft: "5px" }} value={filter} onChange={(e) => setFilter(e.target.value)}>
                            <option value="">All</option>
                            {levels?.map((levelOption) => (
                                <option key={levelOption} value={levelOption.toLowerCase()}>{levelOption}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-sm-8 col-md-3 my-1 my-md-0 d-flex justify-content-md-end">
                        <AddButton onClick={openAddCollabModal}>Add Collaborator</AddButton>
                    </div>
                </form>
                {openAddCollab && <AddCollabModal addOrEdit="Add" onClose={closeAddCollabModal} getList={getCollabs} />}

                {!hasFetched && !loading && (
                    <div className="d-flex justify-content-center my-5 text-center" style={{ color: "#797979" }}>
                        Search for a collaborator by name — or use “Show All” to load everyone.
                    </div>
                )}

                {hasFetched && hasData && <CollaboratorTable list={list} page={1} getCollabs={getCollabs} />}

                {!loading && hasFetched && !hasData && (
                    <div className="d-flex justify-content-center my-5">
                        {lastQuery ? `No collaborators match “${lastQuery}”.` : "No collaborators found"}
                    </div>
                )}
            </div>
        </>
    );
};

export default ManageCollaborators;
